import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import GoogleLogin, { GoogleLoginResponse } from 'react-google-login';
import classNames from 'classnames';
import { FormattedMessage } from '@alltrails/shared/react-intl';
import Apple from '@alltrails/shared/icons/Apple';
import Facebook from '@alltrails/shared/icons/Facebook';
import Google from '@alltrails/shared/icons/Google';
import Button from '@alltrails/shared/denali/components/Button';
import useGoogleClientId from 'hooks/useGoogleClientId';
import useFacebookAppId from 'hooks/useFacebookAppId';
import { ReactFacebookLoginInfo } from 'react-facebook-login';
import * as styles from './AltLoginsForm.module.scss';

type Props = {
  appleLoginHandler: () => void;
  facebookLoginHandler: (response: ReactFacebookLoginInfo) => void;
  googleLoginHandler: (response: GoogleLoginResponse) => void;
};

// https://www.figma.com/file/gZaqAej8HzoFkyrjlQ4cNs/Integrating-Brand-Changes?node-id=1571%3A79911
export default function AltLoginsForm({ appleLoginHandler, facebookLoginHandler, googleLoginHandler }: Props) {
  const facebookAppId = useFacebookAppId();
  const googleClientId = useGoogleClientId();

  return (
    <div className={classNames(styles.content)}>
      <GoogleLogin
        clientId={googleClientId}
        render={renderProps => (
          <Button
            className={classNames(styles.socialButton)}
            onClick={renderProps.onClick}
            text={
              <>
                <span className={classNames(styles.icon, styles.googleIcon)}>
                  <Google />
                </span>
                <FormattedMessage defaultMessage="Continue with Google" />
              </>
            }
            width="full"
          />
        )}
        buttonText="Login"
        onSuccess={googleLoginHandler}
        // don't send onFailure to Bugsnag, these are expected events like popup_closed_by_user
        cookiePolicy="single_host_origin"
      />
      <FacebookLogin
        disableMobileRedirect
        appId={facebookAppId}
        callback={(userInfo: ReactFacebookLoginInfo) => {
          // user closed or clicked Cancel on the popup before logging in
          if (!userInfo.accessToken) {
            return;
          }

          facebookLoginHandler(userInfo);
        }}
        scope="email,user_friends,user_location"
        render={(renderProps: { onClick: () => void }) => (
          <Button
            className={classNames(styles.socialButton)}
            onClick={renderProps.onClick}
            text={
              <>
                <span className={classNames(styles.icon, styles.facebookIcon)}>
                  <Facebook color="currentColor" />
                </span>
                <FormattedMessage defaultMessage="Continue with Facebook" />
              </>
            }
            width="full"
          />
        )}
      />
      <Button
        className={classNames(styles.socialButton)}
        onClick={appleLoginHandler}
        text={
          <>
            <span className={classNames(styles.icon)}>
              <Apple />
            </span>
            <FormattedMessage defaultMessage="Continue with Apple" />
          </>
        }
        width="full"
      />
    </div>
  );
}
